/*  UA_Social_Media_Widget */import './sidebarSocialMedia.scss';